import React from "react";
import {useHeader, useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import UserDetailsPage from "../modules/UserDetails/UserDetailsPage";

export function UserDetails() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "userDetails-page-title",
    defaultMessage: "User Details"
  }));

  const subheader = useSubheader();
  subheader.setDisplaySubheader(false);

  return <UserDetailsPage/>;
}
